// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.notifications-page .room-settings-section-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
}

.notifications-page .room-settings-section-title {
  font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #434343;
  margin: 0;
}

.notifications-page .room-settings-description {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #6A6A6A;
  line-height: 1.2;
  letter-spacing: 0.3px;
  margin: 0;
}

/* Per-user settings note */
.notifications-per-user-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  margin-top: 12px;
  background-color: #F0F4F8;
  border-radius: 8px;
  border-left: 3px solid #5B8DEF;
}

.notifications-per-user-note ion-icon {
  font-size: 18px;
  color: #5B8DEF;
  flex-shrink: 0;
  margin-top: 1px;
}

.notifications-per-user-note span {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #4A5568;
  line-height: 1.4;
}

.notifications-page .room-settings-section-divider {
  height: 1px;
  background-color: #979797;
  width: 100%;
  margin-top: 8px;
}

/* Radio option styles - reusing SecurityPage patterns */
.notifications-page .room-settings-option-group {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.notifications-page .room-settings-option {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 0 16px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: transparent;
}

.notifications-page .room-settings-option:last-child {
  margin-bottom: 0;
}

.notifications-page .room-settings-option.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.notifications-page .room-settings-option input[type="radio"] {
  margin-top: 2px;
  cursor: pointer;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  accent-color: #DE4858;
}

.notifications-page .room-settings-option input[type="radio"]:disabled {
  cursor: not-allowed;
}

.notifications-page .room-settings-option-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.notifications-page .room-settings-option-label {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #2D2D2D;
  line-height: 1.2;
}

.notifications-page .room-settings-option-description {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #6A6A6A;
  line-height: 1.2;
  letter-spacing: 0.3px;
}

/* Loading indicator */
.notifications-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  margin-top: 8px;
}

.notifications-loading span {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #6A6A6A;
}

/* Error message */
.notifications-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  margin-top: 8px;
  background-color: #FEE2E2;
  border-radius: 8px;
}

.notifications-error ion-icon {
  font-size: 20px;
  color: #DC2626;
  flex-shrink: 0;
}

.notifications-error span {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #DC2626;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/RoomSettings/NotificationsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,2FAA2F;EAC3F,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".notifications-page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.notifications-page .room-settings-section-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 16px;\n}\n\n.notifications-page .room-settings-section-title {\n  font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #434343;\n  margin: 0;\n}\n\n.notifications-page .room-settings-description {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #6A6A6A;\n  line-height: 1.2;\n  letter-spacing: 0.3px;\n  margin: 0;\n}\n\n/* Per-user settings note */\n.notifications-per-user-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 12px;\n  margin-top: 12px;\n  background-color: #F0F4F8;\n  border-radius: 8px;\n  border-left: 3px solid #5B8DEF;\n}\n\n.notifications-per-user-note ion-icon {\n  font-size: 18px;\n  color: #5B8DEF;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.notifications-per-user-note span {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  color: #4A5568;\n  line-height: 1.4;\n}\n\n.notifications-page .room-settings-section-divider {\n  height: 1px;\n  background-color: #979797;\n  width: 100%;\n  margin-top: 8px;\n}\n\n/* Radio option styles - reusing SecurityPage patterns */\n.notifications-page .room-settings-option-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.notifications-page .room-settings-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 0 16px;\n  margin-bottom: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  background: transparent;\n}\n\n.notifications-page .room-settings-option:last-child {\n  margin-bottom: 0;\n}\n\n.notifications-page .room-settings-option.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.notifications-page .room-settings-option input[type=\"radio\"] {\n  margin-top: 2px;\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  accent-color: #DE4858;\n}\n\n.notifications-page .room-settings-option input[type=\"radio\"]:disabled {\n  cursor: not-allowed;\n}\n\n.notifications-page .room-settings-option-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n}\n\n.notifications-page .room-settings-option-label {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  color: #2D2D2D;\n  line-height: 1.2;\n}\n\n.notifications-page .room-settings-option-description {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #6A6A6A;\n  line-height: 1.2;\n  letter-spacing: 0.3px;\n}\n\n/* Loading indicator */\n.notifications-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 16px;\n  margin-top: 8px;\n}\n\n.notifications-loading span {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #6A6A6A;\n}\n\n/* Error message */\n.notifications-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  margin-top: 8px;\n  background-color: #FEE2E2;\n  border-radius: 8px;\n}\n\n.notifications-error ion-icon {\n  font-size: 20px;\n  color: #DC2626;\n  flex-shrink: 0;\n}\n\n.notifications-error span {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #DC2626;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
